/**
 * Security utilities for MICoach Frontend
 * Handles token management, XSS prevention, and input sanitization
 */

export const tokenManager = {
  setToken: (token) => {
    if (!token) return;
    try {
      localStorage.setItem('token', token);
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp) {
        localStorage.setItem('token_exp', payload.exp.toString());
      }
    } catch (e) {
      console.error('Error storing token:', e);
      tokenManager.clearAll();
    }
  },

  setRefreshToken: (token) => {
    if (!token) return;
    try {
      localStorage.setItem('refresh_token', token);
    } catch (e) {
      console.error('Error storing refresh token:', e);
    }
  },

  getToken: () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      const parts = token.split('.');
      if (parts.length !== 3) {
        localStorage.removeItem('token');
        localStorage.removeItem('token_exp');
        return null;
      }
      const exp = localStorage.getItem('token_exp');
      if (exp && Date.now() / 1000 > parseInt(exp)) {
        // Token expired - remove ONLY access token, keep refresh token for refresh flow
        localStorage.removeItem('token');
        localStorage.removeItem('token_exp');
        return null;
      }
      return token;
    } catch (e) {
      localStorage.removeItem('token');
      localStorage.removeItem('token_exp');
      return null;
    }
  },

  getRefreshToken: () => {
    return localStorage.getItem('refresh_token');
  },

  clearToken: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('token_exp');
  },

  clearAll: () => {
    const keysToRemove = ['token', 'token_exp', 'refresh_token', 'selectedTeamId'];
    keysToRemove.forEach(key => localStorage.removeItem(key));
    sessionStorage.clear();
  },

  isExpired: () => {
    const exp = localStorage.getItem('token_exp');
    if (!exp) return true;
    return Date.now() / 1000 > parseInt(exp);
  },

  willExpireSoon: (minutes = 30) => {
    const exp = localStorage.getItem('token_exp');
    if (!exp) return true;
    return (parseInt(exp) - Date.now() / 1000) < minutes * 60;
  }
};

export const sanitizeInput = (input) => {
  if (typeof input !== 'string') return input;
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
};

export const isValidEmail = (email) => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email) && email.length <= 254;
};

export const validatePassword = (password) => {
  const issues = [];
  if (password.length < 6) issues.push('Mínimo 6 caracteres');
  if (password.length > 128) issues.push('Máximo 128 caracteres');
  return { isValid: issues.length === 0, issues };
};

const clickCooldowns = new Map();
export const canClick = (actionId, cooldownMs = 1000) => {
  const lastClick = clickCooldowns.get(actionId);
  const now = Date.now();
  if (lastClick && now - lastClick < cooldownMs) return false;
  clickCooldowns.set(actionId, now);
  return true;
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};
